import ActionAreaContainer from './ActionAreaContainer';

export default ActionAreaContainer;
